import { combineReducers } from "redux";
import user from "./user";
import configureStore from './CreateStore'

export default() => {
const rootReducer = combineReducers({ user });

    return configureStore(rootReducer)
}